import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// [F-MININAV2 T-9] „Jelöltek” akció egy projekt-előnézetben — a projekt jelöltjei (candidates
// miniapp), a forrás megjelölésével (a Jelöltek „Vissza”-ja ide tér). A Projektek és a Keresés
// közös gombja.
import React from 'react';
import { openCandidatesMiniapp } from '@core/miniappNav';
export function CandidatesAction({ projectId, from }) {
    if (!projectId || projectId <= 0) {
        return null;
    }
    return (_jsx("div", { className: "pjp-actions", children: _jsxs("button", { type: "button", className: "pjp-action", onClick: () => openCandidatesMiniapp(projectId, from), children: [_jsx("i", { className: "fas fa-users", "aria-hidden": "true" }), " Jel\u00F6ltek"] }) }));
}
